import { Chip, Stack } from '@mui/material';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { minsFromSecs } from 'src/helpers/ConvertToTimezone';

export const TabLabel = ({ item, transcripts }) => {
  const t = transcripts[item.id];
  const mins = minsFromSecs(t?.transcriptDuration ?? 0);
  const dt = t?.transcriptStartTime ? new Date(Number(t.transcriptStartTime) * 1000).toLocaleString() : '—';
  const Icon = (t?.transcriptDirection || '').toLowerCase() === 'inbound' ? CallReceivedIcon : CallMadeIcon;
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ textTransform: 'none' }}>
      <Icon fontSize="small" />
      <span>{mins}m</span>
      <Chip size="small" label={dt} variant="outlined" />
    </Stack>
  );
};
